export const host = "https://crm-api.unepp.ar";
// export const host = "http://localhost:8000";

export const api = `${host}/api`;

export const IMAGES_URL = `${host}/storage-api`;

export const NOTE_IMAGES_PATH = `upload/notes`;
export const STORAGE_TYPE = "public";
